import { call, fork, put, takeLatest } from "redux-saga/effects";
import { API_AUDIT, API_GET } from "../../helpers/api";
import * as actions from "../actions/users";
import { USER_SEARCH_REQUESTED, USER_LOOKUP_REQUESTED } from "../types";

function* watchGetUsers() {
  yield takeLatest(USER_SEARCH_REQUESTED, getUsers);
}
function* watchGetUsersLookup() {
  yield takeLatest(USER_LOOKUP_REQUESTED, getUsersLookup);
}

function* getUsers(action) {
  try {
    const { value, organizationId } = action.payload;
    const res = yield call(apiGetUsers, value, organizationId);
    yield put(actions.userSearchSucceeded(res.data));
  } catch (err) {
    yield put(actions.userSearchFailed());
  }
}
function* getUsersLookup(action) {
  try {
    if (action?.payload?.organizationId !== null) {
      const res = yield call(apiGetUsersLookup, action.payload);
      yield put(actions.userLookupSucceeded(res.data));
    } else {
      yield put(actions.userLookupSucceeded([]));
    }
  } catch (err) {
    yield put(actions.userLookupFailed(err?.response?.data?.message));
  }
}

const apiGetUsers = (value, organizationId) =>
  API_AUDIT("audit/users/search", {
    userSearchParam: value,
    organizationId,
  });

const apiGetUsersLookup = (params) => {
  return API_GET("user/lookup", params);
};

export default function* userSaga() {
  yield fork(watchGetUsers);
  yield fork(watchGetUsersLookup);
}
